import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function Invite() {
  useEffect(() => {
    // Function to detect the user's operating system
    const detectOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Check for iOS
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }
      
      // Check for Android
      if (/android/i.test(userAgent)) {
        return 'android';
      }
      
      // Check for Windows Phone
      if (/windows phone/i.test(userAgent)) {
        return 'windows';
      }
      
      // Default to showing both options
      return 'unknown';
    };

    const redirectToAppStore = () => {
      const os = detectOS();
      
      // App Store URLs
      const appStoreUrl = "https://apps.apple.com/us/app/vreels/id6744721098";
      const playStoreUrl = "https://play.google.com/store/apps/details?id=com.mnk.vreels";
      
      switch (os) {
        case 'ios':
          window.location.href = appStoreUrl;
          break;
        case 'android':
          window.location.href = playStoreUrl;
          break;
        default:
          // For unknown OS or desktop, show both options
          // We'll let the component render instead of redirecting
          break;
      }
    };

    // Small delay to show loading state before redirect
    const timer = setTimeout(redirectToAppStore, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const detectOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
    
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    
    return 'unknown';
  };

  const os = detectOS();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex items-center justify-center">
      <div className="text-center space-y-8 max-w-2xl mx-auto px-4">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <img
            src="/images/logonewnobg.png"
            alt="VREELS Logo"
            className="h-32 md:h-40 w-auto"
            style={{
              filter: "drop-shadow(0 0 20px rgba(255,255,255,0.6))",
            }}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
          <div
            className="h-32 md:h-40 w-32 md:w-40 bg-gradient-to-br from-brand-orange to-grad-orange-1 rounded-3xl items-center justify-center text-white text-2xl md:text-3xl font-bold shadow-2xl"
            style={{ display: "none" }}
          >
            VR
          </div>
        </motion.div>

        {/* Loading State */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="space-y-4"
        >
          <h1 className="text-3xl md:text-4xl font-bold gradient-text-brand">
            {os === 'ios' ? 'Redirecting to App Store...' : 
             os === 'android' ? 'Redirecting to Google Play...' : 
             'Choose Your Platform'}
          </h1>
          
          {os === 'unknown' && (
            <p className="text-lg text-muted-foreground">
              Select your device to download VREELS
            </p>
          )}
          
          {(os === 'ios' || os === 'android') && (
            <p className="text-lg text-muted-foreground">
              You'll be redirected automatically in a moment...
            </p>
          )}
        </motion.div>

        {/* App Store Buttons - Show for unknown OS or as fallback */}
        {(os === 'unknown' || os === 'ios' || os === 'android') && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 sm:gap-8 items-center justify-center mt-8"
          >
            {/* App Store Button */}
            <motion.a
              href="https://apps.apple.com/us/app/vreels/id6744721098"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              <img
                src="/images/appstore copy.png"
                alt="Download on the App Store"
                className="h-16 sm:h-20 md:h-24 w-full sm:w-auto max-w-xs mx-auto hover:brightness-125 hover:scale-105 transition-all duration-300 rounded-xl object-contain"
                style={{ 
                  filter: 'brightness(0.9) contrast(1.2)',
                  background: 'transparent'
                }}
              />
            </motion.a>

            {/* Google Play Button */}
            <motion.a
              href="https://play.google.com/store/apps/details?id=com.mnk.vreels"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              <img
                src="/images/playstore.png"
                alt="Get it on Google Play"
                className="h-16 sm:h-20 md:h-24 w-full sm:w-auto max-w-xs mx-auto hover:brightness-125 hover:scale-105 transition-all duration-300 rounded-xl object-contain"
                style={{ 
                  filter: 'brightness(0.9) contrast(1.2)',
                  background: 'transparent'
                }}
              />
            </motion.a>
          </motion.div>
        )}

        {/* Loading Spinner */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex justify-center"
        >
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-orange"></div>
        </motion.div>
      </div>
    </div>
  );
}
